

import { setFetched } from 'reduxes/slices/api/actions'
import apiRoutes from 'routes/admin_api_routes.json'

import { makeActionCreator } from '../../util/make_action_creator'
import { handleApiError } from '../../util/parse_server_error'

export const SET_RELATED = 'SET_RELATED'
export const setRelated = makeActionCreator(SET_RELATED, 'key', 'related')

export function fetchRelatedByHandle(handle) {
  return function (axios, dispatch) {
    if (!handle) {
      return Promise.reject()
    }
    const path = apiRoutes.admin_api_v1_topics_related.path
    const url = `${path}?handle=${handle}`
    return fetchRelated(axios, dispatch, path, url, handle)
  }
}

export function fetchRelatedByTopic(id) {
  return function (axios, dispatch) {
    if (!id) {
      return Promise.reject()
    }
    const path = apiRoutes.admin_api_v1_topics_related.path
    const url = `${path}?topic_id=${id}`
    return fetchRelated(axios, dispatch, path, url, id)
  }
}

function fetchRelated(axios, dispatch, path, url, key) {
  return axios().get(url).then(
    (result) => {
      dispatch(setRelated(key, result.data.related.data.topics))
      dispatch(setFetched('topics', result.data.records))
      return Promise.resolve(result)
    },
    (result) => {
      handleApiError({
        dispatch,
        result,
        path,
      })
      return Promise.reject(result)
    },
  )
}
